import { Resolution } from 'data/Resolution';
import { changeResolution } from 'state/actions';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class EditResolutionCommand extends Command {
  resolution: Resolution;
  previousResolution: Resolution;
  constructor(resolution: Resolution) {
    super();
    this.resolution = resolution;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      if (firstTime) {
        const {
          flyer: { resolution }
        } = getState();
        this.previousResolution = resolution;
      }
      dispatch(changeResolution(this.resolution));
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      dispatch(changeResolution(this.previousResolution));
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/EditResolutionCommand.ts